<template>
  <div class="layout">
    <h2 class="title blind">통계보고서</h2>
    <div class="box-wrapper flex" style="justify-content: flex-end">
      <div class="search">
        <span class="search-title lg"
          >찾고싶은 보고서를 빠르게 찾아보세요.</span
        >
        <div class="flex w-100 space-bet mobile-width-100">
          <div class="toggle-box">
            <div class="radio-item">
              <label for="radio-reportname">보고서명</label>
              <input
                type="radio"
                value="name"
                v-model="searchBy"
                id="radio-reportname"
                name="report-chk"
                class="ir"
              />
            </div>
            <div class="radio-item">
              <label for="radio-keyword">보고서 분류 키워드</label>
              <input
                type="radio"
                value="keyWord"
                v-model="searchBy"
                id="radio-keyword"
                name="report-chk"
                class="ir"
              />
            </div>
          </div>
          <!-- 보고서명 검색 -->
          <div v-if="searchBy === 'name'" class="comobo-box">
            <div id="searchBox" class="search-bar">
              <label for="sortGubun" class="ir">검색순서</label>
              <select v-model="sortGubun" id="sortGubun">
                <option value="date">최신순</option>
                <option value="visit">조회순</option>
                <option value="title">제목순</option>
              </select>
              <label for="classCode" class="ir">검색카테고리</label>
              <select v-model="classCode" v-show="showClassCode" id="classCode">
                <option value="">전체</option>
                <option
                  v-for="(data, idx) in selectCodeList"
                  v-bind:key="idx"
                  :value="data.code"
                >
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>
          <!-- 키워드 검색 -->
          <div v-else class="comobo-box">
            <div id="searchBox" class="search-bar">
              <select
                name="대상별"
                id="target"
                title="대상별"
                v-model="selectedTarget"
                @change="onClassTargetChange()"
              >
                <option value="0">대분류</option>
                <option
                  v-for="item in targetList"
                  :key="item.anlClsNo"
                  :value="item.anlClsNo"
                >
                  {{ item.anlClsNm }}
                </option>
              </select>
              <select
                name="주제별"
                id="subject"
                title="주제별"
                v-model="selectedSubject"
                @change="onClassSubjectChange()"
              >
                <option value="0">소분류</option>
                <option
                  v-for="item in subjectList"
                  :key="item.anlClsNo"
                  :value="item.anlClsNo"
                >
                  {{ item.anlClsNm }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          class="flex w-100 space-bet keyword-wrap"
          :class="{ 'justify-end': searchBy === 'name' }"
        >
          <div v-if="searchBy !== 'name'" class="tag-add">
            <span class="search-title md">선택한 분류</span>
            <div class="tag-add-list">
              <span
                v-for="tagItem in this.selectedSubjectTags"
                :key="tagItem.anlClsNo"
                class="mx-1 tag-add-item"
                :type="tagItem.type"
                effect="plain"
              >
                #{{ tagItem.anlClsNm }}
                <button @click="removeSubjectTag(tagItem)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="9"
                    height="9"
                    viewBox="0 0 9 9"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1_373)">
                      <path
                        d="M8.10078 0.600525L0.300781 8.40053"
                        stroke="#69686A"
                        stroke-width="0.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M0.300781 0.600525L8.10078 8.40053"
                        stroke="#69686A"
                        stroke-width="0.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1_373">
                        <rect
                          width="8.4"
                          height="8.4"
                          fill="white"
                          transform="translate(0 0.299988)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </span>
            </div>
          </div>
          <div class="report-search-wrap">
            <input v-if="searchBy === 'name'"
              type="search"
              @keyup.enter="goSearch()"
              name="검색창"
              id="search-bar"
              placeholder="검색어를 입력하세요."
              title="검색창"
              v-model="searchText"
              class="report-search"
            />
            <label v-if="searchBy === 'keyWord'" class="report-desc">
            ※ "보고서 분류 키워드"검색은 최근 3년내 발간된 통계보고서를 대상으로 서비스 제공중
            </label>
            
            <button id="btnSearch" class="search-btn" @click="goSearch()">
              검색
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="listBox">
      <!-- 보고서명 검색 -->
      <StatReportListItemName
        v-if="isNameResult === true"
        ref="reportName"
        :nameModel="nameModel"
      />
      <!-- 키워드 검색 -->
      <StatReportListItemKeyWord
        v-else
        ref="reportKeyword"
        :searchModel="searchModel"
        @searchOrderBy="getOrderBy"
      />
    </div>
  </div>
</template>

<script>
import StatReportListItemKeyWord from "@/components/StatReportListItemKeyWord";
import StatReportListItemName from "@/components/StatReportListItemName";
import { fetchClassification } from "@/api/StatReportSearch.js";
import * as api from "@/api/StatReport.js";

export default {
  name: "StatReportNew",
  components: { StatReportListItemKeyWord, StatReportListItemName },

  data() {
    return {
      searchBy: "name", // 검색조건 토글
      isNameResult: "", // 검색 결과 구분

      // 보고서명 검색 조건
      sortGubun: "date",
      classCode: "",
      searchText: "",
      selectCodeList: [], // 조회한 SELECT BOX 분류 목록

      // 키워드 검색 조건
      selectedTarget: "0",
      selectedSubject: "0",
      searchOrderBy: "DESC",
      selectedSubjectTags: [], // 키워드 태그 목록(소분류)

      // 조회한 SELECT BOX 분류 키워드
      targetList: [], // 대분류
      subjectList: [], // 소분류

      searchSubjects: [], // SELECT BOX 선택 옵션(소분류)

      searchModel: {
        // 분류 키워드 검색 조건
        // page: 1,
        // searchText: '',
        // searchTarget: '',
        // searchSubjects: '',
        // searchOrderBy: 'DESC'
      },

      nameModel: {
        // 보고서명 검색 조건
        // sortGubun : 'date',
        // classCode: '',
        // searchText: '',
      },
    };
  },

  props: {
    showClassCode: {
      type: Boolean,
      default: true,
    },
  },

  created() {
    this.searchTargetList();
    this.$nextTick(() => {
      if (this.$route.params.searchModel) {
        this.searchBy = "keyWord";
        this.isNameResult = false;
        this.goSearchPaging(this.$route.params.searchModel.page);
      } else {
        this.searchBy = "name";
        this.goSearch();
      }
      // this.isNameResult = true
    });
  },

  methods: {
    async searchTargetList() {
      if (this.showClassCode) {
        // 통계보고서 selectbox 조회
        const codeData = await api.selectCodeList();

        if (codeData.data.length !== this.selectCodeList.length)
          this.selectCodeList.push(...codeData.data);
      }

      this.targetList = [];

      fetchClassification().then((response) => {
        this.targetList = response.data;
      });
    },

    goSearch(tagText) {
      if (this.searchBy === "name") {
        this.isNameResult = true;

        this.nameModel = {
          searchBy: this.searchBy,
          sortGubun: this.sortGubun,
          classCode: this.classCode,
          statReportSearchText: this.searchText,
        };

        this.$nextTick(() => {
          this.$refs.reportName.searchTextStatReportList();
        });
      } else if (this.searchBy === "keyWord") {
        this.isNameResult = false;

        if (this.selectedTarget !== "0") {
          if (this.selectedSubject === "0") {
            alert("대분류 선택 시 소분류도 선택해 주세요.");
            return;
          }
        }

        this.searchSubjects = [];

        for (const tagData of this.selectedSubjectTags) {
          this.searchSubjects.push(tagData.anlClsNo);
        }

        this.$nextTick(() => {
          // this.searchModel = {
          //     searchBy : this.searchBy,
          //     page: 1,
          //     size: 10,
          //     searchText: '',
          //     searchTarget: this.selectedTarget,
          //     searchSubjects: this.searchSubjects,
          //     searchOrderBy: this.searchOrderBy
          //   }
          this.goSearchPaging(1);
        });
      }
    },

    goSearchPaging(pageIndex) {
      let page = pageIndex;

      if (this.$route.params.searchModel) {
        if (this.$route.params.searchModel.searchBy === "keyWord") {
          if (this.$route.params.searchModel.page) {
            page = Number(this.$route.params.searchModel.page);
          }

          if (this.$route.params.searchModel.searchSubjects) {
            this.searchSubjects.push(
              this.$route.params.searchModel.searchSubjects
            );
          }

          if (this.$route.params.searchModel.searchOrderBy) {
            this.searchOrderBy = this.$route.params.searchModel.searchOrderBy;
          }

          if (this.$route.params.searchModel.selectedSubjectTags) {
            this.selectedSubjectTags =
              this.$route.params.searchModel.selectedSubjectTags;
          }
        }
      }

      this.searchModel = {
        searchBy: this.searchBy,
        page: page,
        size: 10,
        searchText: "",
        searchTarget: this.selectedTarget,
        searchSubjects: this.searchSubjects,
        searchOrderBy: this.searchOrderBy,
        selectedSubjectTags: this.selectedSubjectTags,
      };
    },

    onClassTargetChange() {
      this.selectedSubject = "0";

      if (this.selectedTarget === "") {
        this.subjectList = [];
        return;
      }

      const targetData = this.targetList.find(
        (data) => data.anlClsNo === this.selectedTarget
      );
      if (targetData) {
        this.subjectList = targetData.children;
      } else {
        this.subjectList = [];
      }
    },

    onClassSubjectChange() {
      const subjectData = this.subjectList.find(
        (data) => data.anlClsNo == this.selectedSubject
      );
      if (subjectData) {
        const checkSubjectData = this.selectedSubjectTags.find(
          (data) => data.anlClsNo == subjectData.anlClsNo
        );
        if (!checkSubjectData) {
          this.addSubjectTag(subjectData);
        }
      }
    },

    addSubjectTag(tagItem) {
      for (const targetData of this.targetList) {
        const subjectData = targetData.children.find(
          (data) => data.anlClsNo == tagItem.anlClsNo
        );
        if (subjectData) {
          this.selectedSubjectTags.push({
            type: "info",
            anlClsNo: subjectData.anlClsNo,
            anlClsNm: subjectData.anlClsNm,
          });
        }
      }
      // this.$nextTick(()=> {
      //   this.goSearch()
      // })
    },

    removeSubjectTag(tagItem) {
      const tagIndex = this.selectedSubjectTags.findIndex(
        (data) => data.anlClsNo === tagItem.anlClsNo
      );
      this.selectedSubjectTags.splice(tagIndex, 1);

      // this.$nextTick(()=> {
      //   this.goSearch()
      // })
    },

    getOrderBy(searchOrderBy) {
      this.searchOrderBy = searchOrderBy;
      // this.$nextTick(()=> {
      //   this.goSearch()
      // })
    },
  },
};
</script>
